ACC.password = {

  bindAll: function() {
    $(':password').bind('cut copy paste', function(e) {
      e.preventDefault();
    });
  }
};

$(document).ready(function() {
  ACC.password.bindAll();
});
// Start Code US # 26925
$('document').ready(function() {
  $('#j_username').focus();
  $('#j_username_mbl').focus();
});

// End Code US # 26925
